import { useEffect } from "react"

import { useInboxViewState } from "@/lib/states/global-state"
import { InboxThreadLayout } from "./components/inbox-thread-layout"

export const INBOX_VIEW_MODES = ["focus", "list"] as const

export const InboxScreen = () => {
	const { inboxViewMode, setInboxViewMode } = useInboxViewState()

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if ((e.metaKey || e.ctrlKey) && e.key === "b") {
				e.preventDefault()
				const currentIndex = INBOX_VIEW_MODES.indexOf(inboxViewMode)
				const nextIndex = (currentIndex + 1) % INBOX_VIEW_MODES.length
				const nextMode = INBOX_VIEW_MODES[nextIndex]
				if (nextMode) {
					setInboxViewMode(nextMode)
				}
			}
		}

		window.addEventListener("keydown", handleKeyDown)
		return () => window.removeEventListener("keydown", handleKeyDown)
	}, [inboxViewMode, setInboxViewMode])

	return <InboxThreadLayout />
}
